import { Context } from '../server-middleware/context'
import Unified, { FeaturedProductUpdate, FeaturedTopicFromUnified } from './unified'
import CommunityApi from './community'
import { FeaturedEvent } from '../preact-components/widget-featured-topics/types'

type TopicsListQuery = Array<{id: string|number, type: string} | number>

export interface BackendData {
  featuredTopics: Array<FeaturedTopicFromUnified|FeaturedEvent>
}

const getServerData = async (context: Context, topicsList: TopicsListQuery): Promise<BackendData['featuredTopics']> => {
  const topicIds = []
  const eventIds = []
  const productUpdateIds = []
  const unified = new Unified(context)
  const community = new CommunityApi(context)

  for (const topic of topicsList) {
    if (typeof topic === 'number') {
      topicIds.push(topic)
      continue
    }

    if (topic.type === 'event') {
      eventIds.push(topic.id)
    } else if (topic.type === 'productUpdate') {
      productUpdateIds.push(topic.id)
    } else {
      topicIds.push(topic.id)
    }
  }

  const [
    productUpdates,
    topics,
    events
  ]: [
    Record<string, FeaturedProductUpdate | undefined>,
    Record<string, FeaturedTopicFromUnified | undefined>,
    Record<string, FeaturedEvent | undefined>
  ] = await Promise.all([
    unified.getProductUpdatesIndexedById(productUpdateIds),
    unified.getTopicsIndexedByPublicId(topicIds),
    community.getEventsIndexedByIds(eventIds)
  ])

  return topicsList.map(topic => {
    if (typeof topic === 'number') return topics[topic.toString()]
    if (topic.type === 'productUpdate') return productUpdates[topic.id.toString()]
    if (topic.type === 'event') return events[topic.id.toString()]
    return topics[topic.id.toString()]
  }).filter(isSet)
}

function isSet<T extends any> (item: T | undefined): item is T {
  return !!item
}

export default getServerData
